import React from 'react';

import CountryInfo from '../CountryInfo';

const LOAN_SECTION = {
    title: '600 billion rupees ($8.1 billion) loans',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    Government is pushing banks to approve as much as 600
                    billion rupees ($8.1 billion) of loans by the end of March.
                </li>
                <li>
                    Pubs with a rateable value of between £51,000 and £100,000
                    will receive a £5,000 reduction on their bill.
                </li>
                <li>£100m for a new grant scheme for small businesses.</li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'India pushes state banks to boost lending as coronavirus fears grow',
            url: 'https://www.reuters.com/article/india-banks-lending-coronavirus/india-pushes-state-banks-to-boost-lending-as-coronavirus-fears-grow-sources-idUSL4N2AX1MY',
        },
    ],
};

const BANK_SECTION = {
    title: 'Reserve Bank of India',
    content: (
        <p>
            Long-term repo operations (LTRO) to reduce interest rates and boost
            lending.
        </p>
    ),
    links: [
        {
            title: 'Covid-19 impact: RBI takes steps to infuse liquidity',
            url: 'https://www.thehindubusinessline.com/money-and-banking/rbi-announces-more-liquidity-measures/article31082665.ece',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'India',
    lastUpdated: 'March 17, 2020',
    introSection: (
        <p>
            India has multiple different financial assistance options available.
            Please look over this information and follow up as appropriate.
        </p>
    ),
    sections: [LOAN_SECTION, BANK_SECTION],
};

const IndiaInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default IndiaInfo;
